import React from "react";
import { Box, VStack, Text, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="#f4fafc"
      px={4}
    >
      <VStack
        spacing={4}
        p={8}
        bg="white"
        borderRadius="lg"
        border="1px solid"
        borderColor="#d5e4ea"
        boxShadow="sm"
        maxW="420px"
      >
        <Box as="img" src="/red_eagle/red_eagle_48.png" alt="" w="48px" h="48px" />
        <Text fontSize="xl" fontWeight="600" color="#023047">
          Access Denied
        </Text>
        <Text color="gray.600" textAlign="center">
          Only super admin can access this application.
        </Text>
        <Text color="gray.500" fontSize="sm" textAlign="center">
          If you believe this is an error, please contact support.
        </Text>
        <Button onClick={handleLogout}>Logout</Button>
      </VStack>
    </Box>
  );
};

export default AccessDenied;
